import { FC } from "react";
import { MIN_SEAT_COLUMN_WIDTH } from "../RowSeating/RowSeating";

const ColumnHeader: FC<{ colMap: Map<number, string>; isMobile?: boolean }> = ({ colMap, isMobile }) => {
  const colsRendered = Array.from(colMap.entries());

  return (
    <div
      className="grid w-full items-center gap-2 md:gap-2 rounded-xl p-1 text-font-default!"
      style={{ gridTemplateColumns: `repeat(${colsRendered.length}, minmax(${isMobile ? MIN_SEAT_COLUMN_WIDTH : "0"},1fr))` }}
    >
      {colsRendered.map(([key, label]) =>
        label === "GAP" ? (
          <div key={`gap-${key}`} />
        ) : (
          <div key={`${label}-${key}`} className="flex items-center justify-center font-poppins text-xs font-medium text-font-subtle">
            {label}
          </div>
        ),
      )}
    </div>
  );
};

export default ColumnHeader;
